// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expand-body {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, padding-top 0.3s ease-in-out, padding-bottom 0.3s ease-in-out;
}
.expand-body.is-open {
  max-height: 2000px;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/components/layout/checkbox-card/checkbox-card.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gIACE;AAAJ;AAKE;EACE,kBAAA;EACA,UAAA;AAHJ","sourcesContent":[".expand-body {\r\n  max-height: 0;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n  transition:\r\n    max-height 0.3s ease-in-out,\r\n    opacity 0.3s ease-in-out,\r\n    padding-top 0.3s ease-in-out,\r\n    padding-bottom 0.3s ease-in-out;\r\n\r\n  &.is-open {\r\n    max-height: 2000px;\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
